import { buildCsv, downloadTextFile } from "./csv";
import type { Ingredient, Store, StoreSection } from "../types";

function formatStoreSections(
  i: Ingredient,
  stores: Store[],
  sectionsByStore: Map<string, StoreSection[]>
): string {
  const parts = (i.storeSections ?? []).map((m) => {
    const store = stores.find((s) => s.id === m.storeId);
    const section = sectionsByStore.get(m.storeId)?.find((s) => s.id === m.sectionId);
    return `${store?.name ?? "?"}: ${section?.name ?? "?"}`;
  });
  return parts.join(" | ");
}

/** Exportuje katalog surovin do CSV (středník, UTF-8 BOM). */
export function exportIngredientsToCsv(
  ingredients: Ingredient[],
  stores: Store[],
  sectionsByStore: Map<string, StoreSection[]>
) {
  const sorted = [...ingredients].sort((a, b) => a.name.localeCompare(b.name, "cs"));

  const header = ["název", "jednotka", "velikost_balení", "na_váhu", "sekce_v_obchodech"];
  const rows = sorted.map((i) => [
    i.name,
    i.unit,
    i.packageSize === 0 ? "" : i.packageSize,
    i.packageSize === 0 ? "ano" : "ne",
    formatStoreSections(i, stores, sectionsByStore),
  ]);

  const csv = buildCsv([header, ...rows]);
  const date = new Date().toISOString().slice(0, 10);
  downloadTextFile(`suroviny-${date}.csv`, csv);
}
